import React from 'react';
import { Progress } from 'semantic-ui-react';

export default function ApplicationDetailedReviewTable({ ratings }) {
  return (
    <table style={{ width: '100%', fontSize: '0.9em' }}>
      <tbody>
        {ratings &&
          ratings.map((rating) => (
            <tr key={rating.star}>
              <td width='50'>{rating.star} star</td>
              <td>
                {rating.percent && rating.percent > 0 ? (
                  <Progress
                    percent={rating.percent}
                    warning
                    style={{ marginTop: '20px' }}
                  />
                ) : (
                  <Progress />
                )}
              </td>
              <td>
                <span style={{ marginLeft: '10px' }}>{rating.percent}%</span>
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  );
}
